import React from 'react';
import { PropertyBuildingsList } from '../property-buildings-list';

export function PropertyBuildings() {
  return <PropertyBuildingsList />;
}
